/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';
import UserService from '../services/user-service.js';

var _registerToActions = function(action){

    var isValidDueDate = function(date) {
        var timeDate = new Date(date.replace(' ', 'T'));
        timeDate.setDate(timeDate.getDate()+1);
        var currentDate = new Date();
        return currentDate < timeDate;
    }

    switch(action.actionType)
    {
        case Constants.GET_CLASS_ASSIGNMENTS: {
            this.archivedLanguages = action.response.archivedLanguages;
            break;
        }
        case Constants.GET_ALL_FAV:
            this.favs = action.response || [];
            this.emit(Constants.GET_ALL_FAV);
            break;
        case Constants.GET_STUDENT_MESSAGES:
            this.messages = action.response || [];
            this.emit(Constants.GET_STUDENT_MESSAGES);
            break;
        case Constants.GET_MY_ASSIGNMENTS:
            var assignmentArray = [];
            var archiveArray = [];
            for (var i = 0; i < action.response.homework.length; i++) {
                if(isValidDueDate(action.response.homework[i].due)) {
                    assignmentArray.push(action.response.homework[i]);
                } else { 
                    archiveArray.push(action.response.homework[i]);
                }
            }
            this.assignments = assignmentArray;
            this.archive2 = archiveArray;
            if (this.archive2 == undefined) {
                this.archived = this.archive1;
            } else {
                this.archived = this.archive2.concat(this.archive1);
            }
            this.archivedLanguages = action.response.archivedLanguages;
            this.emit(Constants.GET_MY_ASSIGNMENTS);
            this.emit(Constants.GET_MY_ARCHIVED_ASSIGNMENTS);
            break;
        case Constants.GET_MY_ARCHIVED_ASSIGNMENTS:
            this.archive1 = action.response || [];
            if (this.archive2 == undefined) {
                this.archived = this.archive1;
            } else {
                this.archived = this.archive2.concat(this.archive1);
            }
            this.emit(Constants.GET_MY_ARCHIVED_ASSIGNMENTS);
            break;
        case Constants.EXISITNG_ACCOUNT_STUDENTS:
            this.exisitingStudents = action.response.existingStudents
            this.emit(Constants.EXISITNG_ACCOUNT_STUDENTS);
            break;
        case Constants.GET_PERSONAL_INFROMATION:
            this.personal = action.response
            this.emit(Constants.GET_PERSONAL_INFROMATION);
            break;

        case Constants.IS_ACCOUNT_REGISTERED:
            console.log(action.response);
            this.account.is_registered = action.response.isRegistered
            this.emit(Constants.IS_ACCOUNT_REGISTERED);
            break;
    }

};

class UserStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.usersAccounts =  [];
        this.account = {account_uid:null};
        this.personal = {}
        this.archive1 = [];
        this.archive2 = [];
        this.favs = [];
    }

    setAccount(accountUID){
        this.account = accountUID;
        UserService.isAdminRegistered();
    }

    getPersonal()
    {
        return this.personal || {};
    }

}

export default new UserStore();